import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import { CodeBlock } from "component/shared/code-block";
import { User } from "model/user";

interface OwnProps {
	embedCode?: string;
	user: User;
	children?: React.ReactNode;
}

type Props = OwnProps & WithStyles<typeof styles>;

/**
 * The body of a widget's Generate Embed Code modal (MAX-4403): a "Customize Widget" block for the
 * widget's options, when it has any, then the embed code. The code stays disabled, with a
 * placeholder, until the required options are filled in (`embedCode` is left out until then).
 * Preview Widget is not drawn: it ships later (WFF-1).
 */
class Component extends React.Component<Props> {

	public render() {
		const { classes = {}, children, user, embedCode } = this.props;
		return (
			<div className={classes.root}>
				{children && (
					<>
						<div className={classes.section}>
							<Mui.Typography variant="h3" className={classes.subHead}>
								Customize Widget
							</Mui.Typography>
							{children}
						</div>
						<Mui.Divider />
					</>
				)}
				<div className={classes.section}>
					<Mui.Typography variant="h3" className={classes.subHead}>
						Embed Code
					</Mui.Typography>
					<CodeBlock
						refreshed
						code={embedCode || ""}
						disabled={!embedCode}
						placeholder="Fill all required options above to generate your embed code"
						language={user.websitePlatform.textEmbedCode ? "text" : "html"}
					/>
				</div>
			</div>
		);
	}
}

export const WidgetConfigLayout = withStyles(Component, styles);
